export const warningSvg = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12 17.5V18V17.5Z" fill="white"/>
<path d="M12 9V14M12 17.5V18" stroke="#EC5351" stroke-width="2" stroke-linecap="round"/>
<path d="M11.3065 3.17176C11.6199 2.60941 12.3801 2.60941 12.6935 3.17177L22.1339 20.1118C22.4767 20.7269 22.0222 21.4167 21.4404 21.4167H2.55959C1.97775 21.4167 1.52327 20.7269 1.86609 20.1118L11.3065 3.17176Z" stroke="#EC5351" stroke-width="1.5"/>
</svg>`;
